import React from 'react';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { Box, Item } from 'devextreme-react/box';
import { Popup as DialogPopup } from 'devextreme-react/popup';

interface Props {
    visible: boolean;
    onRetry: () => void;
}

export default function ServiceUnavailablePopup(props: Props) {
    return (
        <DialogPopup
            visible={props.visible}
            dragEnabled={false}
            showCloseButton={false}
            showTitle={false}
            width={500}
            height={300}
            hideOnOutsideClick={false}
        >
            <div className="serviceunavailable-container">
                <div className="serviceunavailable-header">
                    <Box direction="row" width="100%" height={50} crossAlign='center'>
                        <Item baseSize="auto">
                            <LoadIndicator height={30} width={30} />
                        </Item>
                        <Item baseSize="auto">
                            <h2 className="dx-theme-accent-as-text-color">One moment please...</h2>
                        </Item>
                    </Box>
                </div>

                <div className="serviceunavailable-body">
                    <p>
                        We're having trouble reaching our servers right now.
                    </p>
                    <p>
                        This is usually resolved within a few minutes. Please try again shortly.
                    </p>
                    <p>
                        If you were in the middle of editing data, you may need to re-save when you return.
                    </p>
                </div>

                <div className="serviceunavailable-footer">
                    <Button
                        text="Resume Session"
                        type="default"
                        stylingMode="contained"
                        onClick={props.onRetry}
                        width={160}
                    />
                    {/* <p className="">
                        If this message persists, the system may be under heavy load.
                    </p> */}
                </div>
            </div>
        </DialogPopup>
    );
};